export default __webpack_public_path__ + "static/venue_location@2x-714d2333acef21a6cf2b3ab75ceb34e8.png";